import {useQuery} from '@tanstack/react-query'
import apiService from "../services/api";

interface ApiResponse {
    client_secret: string
}

const fetchReserveClientSecret = async () => {
    const response = await apiService.reserve()
    return response.data;
};

export const useReserveClientSecret = () => {
    return useQuery<ApiResponse>({
        queryKey: ['reserve'],
        queryFn: fetchReserveClientSecret,
        staleTime: 1000 * 60 * 30
    });
};